module.exports = __webpack_public_path__ + "img/index12.f0f0532c.png";